import './App.css';
import hotImg from './assets/holder.png';
import HeaderComponent from './components/Header';
import FooterComponent from './components/Footer';
import React, { useState, useEffect, useRef } from 'react';
import { Flex, Layout, Tabs, Table } from 'antd';
import unit from './unit';
import { Link, useNavigate } from 'react-router-dom';
const { Content } = Layout;

// 股东增减仓页面元信息配置
const metaConfig = {
  title: '股东增减仓-实时查看最新个股的股东明细_仓位在线',
  keywords: '股东,十大股东,持仓,股票',
  description: '仓位在线股东增减仓频道：投资者通过持仓变动快速查询个股股东明细，通过对知名/重要股东增持、减持、新进的深入分析，快速做出有利的投资决策'
};

// 股东增减仓
const Increase = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [page, setPage] = useState(1); // 直接使用默认值1
    const [dataSource, setDataSource] = useState([]);
    const [type, setType] = useState("1"); // 直接使用默认值"1"
    const [date, setDate] = useState(''); // 默认值为空
    const [dayList, setDateList] = useState([]);
    const childRef = useRef(null);

    // 存储当前点击的股票代码
    const [activeStockCode, setActiveStockCode] = useState('');

    // 存储当前的排序字段
    const [sortField, setSortField] = useState('change_percent'); // 直接使用默认值'change_percent'
    // 存储当前的排序顺序
    const [sortOrder, setSortOrder] = useState('desc'); // 直接使用默认值'desc'
    // 存储总数据量
    const [count, setCount] = useState(0);

    // 更新页面元信息
    const updateMetaInfo = () => {
        // 设置页面标题
        document.title = metaConfig.title;
        
        // 设置keywords
        const metaKeywords = document.querySelector('meta[name="keywords"]');
        if (metaKeywords) {
            metaKeywords.setAttribute('content', metaConfig.keywords);
        } else {
            const newMeta = document.createElement('meta');
            newMeta.setAttribute('name', 'keywords');
            newMeta.setAttribute('content', metaConfig.keywords);
            document.head.appendChild(newMeta);
        }
        
        // 设置description
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
            metaDescription.setAttribute('content', metaConfig.description);
        } else {
            const newMeta = document.createElement('meta');
            newMeta.setAttribute('name', 'description');
            newMeta.setAttribute('content', metaConfig.description);
            document.head.appendChild(newMeta);
        }
    };

    const getSortOrder = (field) => {
        if (field === sortField) {
            return sortOrder === 'asc' ? 'ascend' : 'descend';
        }
        return null;
    };

    const getDateList = () => {
        const path = '/pc/gudong/getDateList';
        unit.httpGet(path, { "type": type }, (data) => {
            if (data.length > 0) {
                const sortedFilters = data.sort((a, b) => b.day - a.day);
                sortedFilters.map(item => ({
                    day: item.day,
                    show: item.show,
                }));
                setDateList(sortedFilters); // 设置日期列表
                if (!date) {
                    // 默认选择最新的日期
                    setDate(sortedFilters[0].day);
                }
            }
        });
    };

    const tabsItems = [
        { "label": "十大流通股东", "key": "1" },
        { "label": "十大股东", "key": "2" }
    ];

    const columns = [
        {
            title: '序列',
            dataIndex: 'index',
            key: 'index',
            align: 'center',
        },
        {
            title: '股票代码',
            dataIndex: 'stock_code',
            key: 'stock_code',
            align: 'center',
        },
        {
            title: '股票名称',
            dataIndex: 'stock_name',
            key: 'stock_name',
            align: 'center',
            render: (text, record) => (
                <Link
                    to={`/particulars/${record.stock_code}`}
                    target="_blank"
                    onClick={() => setActiveStockCode(record.stock_code)}
                    style={{
                        color: '#4E86E2',
                        textDecoration: activeStockCode === record.stock_code ? 'underline' : 'none'
                    }}
                >
                    {text}
                </Link>
            ),
        },
        {
            title: '上季度持仓占比',
            dataIndex: 'pre_percent',
            key: 'pre_percent',
            sorter: true,
            sortDirections: ['descend', 'ascend'],
            align: 'center', // 居中对齐
            render: (text) => <span>{text}%</span>,
        },
        {
            title: '本季度持仓占比',
            dataIndex: 'percent',
            key: 'percent',
            sorter: true,
            sortDirections: ['descend', 'ascend'],
            align: 'center', // 居中对齐
            render: (text) => <span>{text}%</span>,
        },
        {
            title: '持仓变动',
            dataIndex: 'change_percent',
            key: 'change_percent',
            sorter: true,
            defaultSortOrder: getSortOrder('change_percent'),
            sortDirections: ['descend', 'ascend'],
            align: 'center', // 居中对齐
            render: (text) => {
                const isPositive = text > 0;
                return (
                    <span style={{ color: isPositive ? '#F23031' : 'green' }}>
                        {isPositive ? '+' : ''}{text}%
                    </span>
                );
            },
        },
        {
            title: '上季度价格',
            dataIndex: 'pre_price',
            key: 'pre_price',
            align: 'center', // 居中对齐
            sorter: true,
            sortDirections: ['descend', 'ascend'],
        },
        {
            title: '本季度价格',
            dataIndex: 'price',
            key: 'price',
            align: 'center', // 居中对齐
            sorter: true,
            sortDirections: ['descend', 'ascend'],
        },
        {
            title: '区间涨幅',
            dataIndex: 'zdf',
            key: 'zdf',
            align: 'center', // 居中对齐
            sorter: true,
            sortDirections: ['descend', 'ascend'],
            render: (text) => {
                const isPositive = text > 0;
                return (
                    <span style={{ color: isPositive ? '#F23031' : 'green' }}>
                        {isPositive ? '+' : ''}{text}%
                    </span>
                );
            },
        },
        {
            title: '最新价格',
            dataIndex: 'close',
            key: 'close',
            align: 'center', // 居中对齐
            sorter: true,
            sortDirections: ['descend', 'ascend'],
        },
        {
            title: '最新累计涨幅',
            dataIndex: 'days20_zdf',
            key: 'days20_zdf',
            align: 'center', // 居中对齐
            sorter: true,
            sortDirections: ['descend', 'ascend'],
            render: (text) => {
                const isPositive = text > 0;
                return (
                    <span style={{ color: isPositive ? '#F23031' : 'green' }}>
                        {isPositive ? '+' : ''}{text}%
                    </span>
                );
            },
        },
    ];

    const getHotList = (type, date, currentPage = page, pagesize = 50, currentSortField = sortField, currentSortOrder = sortOrder) => {
        const path = '/pc/gudong/getGudongChangeList';
        unit.httpGet(path,
            {
                "type": type,
                "date": date,
                "page": currentPage,
                "pageSize": pagesize,
                "sortField": currentSortField,
                "sortOrder": currentSortOrder
            }, (data) => {
                if (data.list.length > 0) {
                    const startIdx = (currentPage - 1) * pagesize; // 计算当前页的起始序号
                    const _dataSource = data.list.map((item, index) => ({
                        key: item.stock_code,
                        index: startIdx + index + 1, 
                        stock_code: item.stock_code,
                        stock_name: item.stock_name,
                        percent: item.percent,
                        pre_percent: item.pre_percent,
                        change_percent: item.change_percent,
                        pre_price: item.pre_price,
                        price: item.price,
                        zdf: item.zdf,
                        close: item.close,
                        days20_zdf: item.days20_zdf,
                    }));
                    setDataSource(_dataSource);
                    setCount(data.count);
                }
                setLoading(false);
            });
    };

    //处理表格变化事件，如分页、排序、筛选
    const handleTableChange = (pagination, filters, sorter) => {
        const newSortField = sorter.field || null;
        const newSortOrder = sorter.order === 'ascend' ? 'asc' : (sorter.order === 'descend' ? 'desc' : null);
        // 更新排序字段和排序顺序
        setSortField(newSortField);
        setSortOrder(newSortOrder);
        setPage(pagination.current);
        // 调用获取数据的函数，传递排序信息
        getHotList(type, date, pagination.current, 50, newSortField, newSortOrder);
    };

    // 切换按钮（十大流通股东/十大股东）
    const onTabsChange = (key) => {
        if (key !== type) {
            // 如果切换到不同的上级按钮，则重置日期按钮和分页按钮的值为默认
            setDate('');
            setPage(1);
        }
        setType(key);
        getHotList(key, date, page, 50, sortField, sortOrder);
    };

    // 获取数据
    useEffect(() => {
        getDateList();
        updateMetaInfo(); // 初始化时设置元信息
    }, [type]);

    useEffect(() => {
        if (date) {
            getHotList(type, date, page, 50, sortField, sortOrder);
        }
    }, [type, date, sortField, sortOrder]);

    // 点击日期标签
    const onTagClick = (v) => {
        if (v !== date) {
            // 如果点击的日期与当前日期不同，则重置分页按钮
            setPage(1);
        }
        setDate(v);
    };

    return (
        <div className="App">
            <Flex gap="middle" wrap>
                <Layout>
                    <HeaderComponent ref={childRef}></HeaderComponent>
                    <Content>
                        <div className='hot-container'>
                            <div className='block-title'>
                                <img className='title-icon' src={hotImg}/> <span style={{verticalAlign: 'middle'}}>股东增减仓</span>
                            </div>
                            <div className="tabs-container" style={{width:"50%", overflow: 'hidden'}}>
                                <Tabs defaultActiveKey={type} items={tabsItems} value={type} onChange={onTabsChange} />
                            </div>
                            <div className='tag-container'>
                                <Flex gap="small" wrap>
                                    {dayList.map((item, index) => (
                                        <span 
                                            key={index}
                                            onClick={() => onTagClick(item.day)}
                                            className={date === item.day ? "tag active" : "tag"}
                                        >
                                            {item.show}
                                        </span>
                                    ))}
                                </Flex>
                            </div>
                            <div className='table'>
                                <Table 
                                    size='small' 
                                    locale={{ cancelSort: "点击取消排序", triggerAsc: "点击升序", triggerDesc: "点击降序", emptyText: "暂无数据" }} 
                                    pagination={{
                                        current: page,
                                        pageSize: 50,
                                        total: count,
                                        showSizeChanger: false,
                                        showQuickJumper: true,
                                        locale: {
                                            items_per_page: '条/页',
                                            jump_to: '跳至',
                                            jump_to_confirm: '确定',
                                            page: '页',
                                            prev_page: '上一页',
                                            next_page: '下一页'
                                        }
                                    }}
                                    onChange={handleTableChange}
                                    columns={columns} 
                                    dataSource={dataSource} 
                                    rowClassName="custom-row"
                                    sortField={sortField}
                                    sortOrder={sortOrder === 'asc' ? 'ascend' : (sortOrder === 'desc' ? 'descend' : null)}
                                ></Table>
                            </div>
                        </div>
                    </Content>
                    <FooterComponent/>
                </Layout>
            </Flex>
        </div>
    )
}

export default Increase;